// components/Trackable.tsx
'use client';

import { trackEvent } from '@/utils/mixpanelClient.util';
import React from 'react';

interface TrackableProps {
  children: React.ReactNode;
  eventName: string;
  eventScope?: string;
  eventProps?: Record<string, any>;
  onClick?: (e: React.MouseEvent) => void;
  tag?: keyof React.JSX.IntrinsicElements;
  className?: string;
  [key: string]: any; 
}

const Trackable: React.FC<TrackableProps> = ({
  children,
  eventName,
  eventScope,
  eventProps = {},
  onClick,
  tag = 'div',
  className,
  ...rest
}) => {
  const Tag = tag as any;

  const handleClick = (e: React.MouseEvent) => {
    trackEvent(`${eventName}: ${eventScope}`, eventProps);
    onClick?.(e);
  };

  return (
    <Tag onClick={handleClick} className={className} {...rest}>
      {children}
    </Tag>
  );
};

export default Trackable;